import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
  LabelList
} from "recharts";

const COLORS = [
  "#56c7dd", "#74aee8", "#f1c98a", "#1d8ea5",
  "#9fdfff", "#c98654", "#8dc9b7", "#5e9fd2",
  "#f0b97a", "#d7e9f7"
];

const DeveloperPieChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="chart-empty">No data available.</p>;
  }

  const enrichedData = [...data]
    .sort((a, b) => b.count - a.count)
    .map((entry, index) => ({
    ...entry,
      fill: COLORS[index % COLORS.length],
    }));
  const totalBugs = enrichedData.reduce((sum, entry) => sum + entry.count, 0);
  const chartHeight = Math.max(320, enrichedData.length * 56);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-tooltip">
          <p className="chart-tooltip-name">{payload[0].payload.name}</p>
          <p
            className="chart-tooltip-value"
            style={{ color: payload[0].payload.fill }}
          >
            {`Bugs: ${payload[0].value}`}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-shell">
      <div className="chart-summary">
        <span>Total Bugs</span>
        <strong>{totalBugs}</strong>
      </div>
      <div className="chart-scroll">
        <div className="chart-wrap" style={{ height: `${chartHeight}px` }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={enrichedData}
              layout="vertical"
              margin={{ top: 10, right: 18, left: 18, bottom: 10 }}
            >
              <CartesianGrid
                stroke="rgba(158, 178, 197, 0.12)"
                strokeDasharray="4 4"
                horizontal={false}
              />
              <XAxis
                type="number"
                allowDecimals={false}
                tickLine={false}
                axisLine={false}
                tick={{ fill: "var(--ink-soft)", fontSize: 12 }}
              />
              <YAxis
                type="category"
                dataKey="name"
                width={132}
                tickLine={false}
                axisLine={false}
                tick={{ fill: "var(--ink-strong)", fontSize: 12, fontWeight: 600 }}
              />
              <Tooltip
                cursor={{ fill: "rgba(86, 199, 221, 0.08)" }}
                content={<CustomTooltip />}
              />
              <Bar
                dataKey="count"
                radius={[0, 12, 12, 0]}
                barSize={26}
              >
                <LabelList
                  dataKey="count"
                  position="insideRight"   // or "insideRight"
                  style={{ fill: "#fff", fontSize: 12, fontWeight: 600 }}
                />
                {enrichedData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DeveloperPieChart;
